<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0

@component
Renders the file-upload transcription tab content.
Composes TranscriptionUploadSection (drag-and-drop uploader) and
TranscriptionJobsList (polling job status list).
Starts the TranscriptionPolling background poller on mount and stops it on destroy.

Props
─────
descriptionHtml – pre-rendered HTML description shown above the upload section.
-->
<script>
import { onMount } from 'svelte';
import { TranscriptionPolling } from '../../libs/TranscriptionAPI/TranscriptionPolling';
import TranscriptionJobsList from './TranscriptionJobsList.svelte';
import TranscriptionUploadSection from './TranscriptionUploadSection.svelte';

/** @type {string} Pre-rendered HTML description shown above the upload section. */
export let descriptionHtml = '';

onMount(() => {
  const poller = new TranscriptionPolling();
  poller.start();
  return () => poller.stop();
});
</script>

<div class="tab-description">
  <p class="textlink">{@html descriptionHtml}</p>
</div>
<TranscriptionUploadSection />
<TranscriptionJobsList />
